














































































































































































































































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator'
import {
  IcoachSkillForm,
  IcoachSkillShortInfo,
  SurveyInfo,
  TsAbstractUser,
  TsNewUserForm,
  TsRateeUser,
  TsRaterUser,
  TsUserDto,
  User
} from '@/interfaces'
import {
  Getter
} from 'vuex-class'
import TsService from '@/services/TsService'
import TsAddUserModal from '@/components/modals/TsAddUserModal.vue'
import TsAddSkillModal from '@/components/modals/TsAddSkillModal.vue'
import SimpleConfirmModal from '@/components/modals/SimpleConfirmModal.vue'
import ManagerRateeCard from '@/components/360/ManagerRateeCard.vue'
import dayjs from 'dayjs'

  @Component({
    name: 'ManagerRateePage',
    components: {
      TsAddUserModal,
      TsAddSkillModal,
      SimpleConfirmModal,
      ManagerRateeCard
    }
  })
export default class ManagerRateePage extends Vue {
    @Prop()
    tsSurveyId!: number;

    @Prop()
    tsManagerRateeId!: number;

    @Getter('user/isAuthenticated')
    isAuthenticated!: boolean;

    @Getter('survey/getDisplayedBaseSurveyInfo')
    surveyInfo!: SurveyInfo;

    @Getter('ts/getUsers')
    tsUser!: TsUserDto;

    @Getter('ts/getManager')
    tsManager!: TsAbstractUser;

    @Getter('user/currentUser')
    user!: User;
    @Getter('ts/hasRoleRater')
    hasRoleRater!: boolean;
    @Getter('ts/hasRoleManager')
    hasRoleManager!: boolean;

    ratee: TsRateeUser | null = null;
    raterList: TsRaterUser[] = [];
    groupedSkillList: {
      [key: number]: IcoachSkillShortInfo[]
    } = {};
    modalError: string = '';
    raterToRemove: TsRaterUser | null = null;
    skillToRemove: IcoachSkillShortInfo | null = null;
    checked: Array < string > = [];
    checkedItemGroup: Array < string > = [];
    checkedAllGroup: any = {};
    usersTableFields: any[] = [
      {
        label: '',
        key: 'checked',
        sortable: false
      },
      {
        label: 'Name',
        key: 'fullName',
        sortable: true
      },
      {
        label: '',
        key: 'actions',
        sortable: false
      }
    ]
    skillTableFields: any[] = [
      {
        label: '',
        key: 'checked',
        sortable: false
      },
      {
        label: 'Name',
        key: 'name',
        sortable: true
      },
      {
        label: '',
        key: 'actions',
        sortable: false
      }
    ]

    get formattedDate (): string {
      if (this.ratee !== null && this.ratee.expiryTime) {
        return dayjs(this.ratee.expiryTime.toString()).format('DD/MM/YYYY')
      }
      return dayjs(new Date().toString()).format('DD/MM/YYYY')
    }

    get formattedExpiryDate (): string {
      if (this.ratee !== null && this.ratee.isLive && this.ratee.expiryTime) {
        return dayjs(this.ratee.expiryTime.toString()).format('DD/MM/YYYY')
      }
      return ''
    }

    get checkedAll () {
      return this.raterList ? this.checked.length === this.raterList.length : false
    }

    set checkedAll (value: any) {
      const selected: Array < string > = []
      if (value) {
        this.raterList.forEach(function (user: any) {
          selected.push(user.id)
        })
      }

      this.checked = selected
    }

    async removeCheckedAll () {
      this.checked = []
    }

    async checkGroup (group: any) {
      const selected: Array < string > = []

      this.checkedAllGroup[group] = !this.checkedAllGroup[group]

      for (const [key, value] of Object.entries(this.checkedAllGroup)) {
        if (key !== group) {
          this.checkedAllGroup[key] = false
        }
      }

      if (this.checkedAllGroup[group]) {
        this.groupedSkillList[group].forEach((item: any) => {
          selected.push(item.id)
        })
        this.checkedItemGroup = selected
      } else {
        this.checkedItemGroup = []
      }
    }

    async created () {
      if (!this.isAuthenticated) {
        await this.$router.push({
          name: 'notFound'
        })
      }

      await this.checkRatee()

      this.raterList = await TsService.getRaterList(this.tsManagerRateeId)
      const skillList = await TsService.getSkillList(this.tsManagerRateeId)
      this.groupedSkillList = this.groupSkills(skillList)
    }

    async checkRatee () {
      try {
        this.ratee = await TsService.getRateeInfoById(this.tsManagerRateeId)
      } catch (error) {
        if ('response' in error && error.response.status === 404) {
          await this.$router.push({
            name: 'notFound'
          })
        } else {
          throw error
        }
      }
    }

    handleCancelModal () {
      this.modalError = ''
      this.$modal.hide('new-rater-modal')
    }

    async handleConfirmModal (rater: TsNewUserForm) {
      try {
        if (!this.ratee) {
          return
        }

        const newRater = await TsService.addRater(
          this.tsManager.id,
          this.ratee.id,
          rater
        )
        this.raterList.push(newRater)
        this.$modal.hide('new-rater-modal')
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data
          this.modalError = detail
        } else {
          throw error
        }
      }
    }

    handleChangedModal () {
      this.modalError = ''
    }

    addNewRater () {
      this.$modal.show('new-rater-modal')
    }

    async removeRater (tsRater: TsRaterUser) {
      this.raterToRemove = tsRater
      this.$modal.show('confirm-remove-rater-modal')
    }

    async removeSkill (skill: IcoachSkillShortInfo) {
      this.skillToRemove = skill
      this.$modal.show('confirm-remove-skill-modal')
    }

    goToList () {
      return this.$router
        .push({
          name: 'survey.ts.dashboard',
          params: {
            tsSurveyId: this.tsSurveyId.toString()
          }
        })
        .catch(() => {})
    }

    hideConfirmRemoveRaterModal () {
      this.raterToRemove = null
      this.$modal.hide('confirm-remove-rater-modal')
      this.modalError = ''
    }

    hideConfirmRemoveSkillModal () {
      this.skillToRemove = null
      this.$modal.hide('confirm-remove-skill-modal')
      this.modalError = ''
    }

    async confirmRemoveRaterModal () {
      if (!this.ratee || !this.raterToRemove) {
        return
      }

      try {
        await TsService.removeRater(
          this.tsManager.id,
          this.ratee.id,
          this.raterToRemove.id
        )
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data

          this.modalError = detail
          return
        } else {
          throw error
        }
      }

      this.$modal.hide('confirm-remove-rater-modal')

      this.raterList = await TsService.getRaterList(this.tsManagerRateeId)
    }

    async confirmRemoveSkillModal () {
      if (!this.ratee || !this.skillToRemove) {
        return
      }

      try {
        await TsService.removeSkill(
          this.tsManager.id,
          this.ratee.id,
          this.skillToRemove.id
        )
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data

          this.modalError = detail
          return
        } else {
          throw error
        }
      }

      this.$modal.hide('confirm-remove-skill-modal')

      const skillList = await TsService.getSkillList(this.tsManagerRateeId)

      this.groupedSkillList = this.groupSkills(skillList)
    }

    async addNewSkill () {
      this.$modal.show('new-skill-modal')
    }

    handleCancelSkillModal () {
      this.modalError = ''
      this.$modal.hide('new-skill-modal')
    }

    async handleConfirmSkillModal (skill: IcoachSkillForm) {
      let newRateeSkill: IcoachSkillShortInfo | null = null

      try {
        if (!this.ratee) {
          return
        }

        newRateeSkill = await TsService.addSkill(
          this.tsManager.id,
          this.ratee.id,
          skill
        )
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data
          this.modalError = detail

          return
        } else {
          throw error
        }
      }

      this.$modal.hide('new-skill-modal')
      this.modalError = ''

      if (!newRateeSkill) {
        return
      }

      const categoryList = this.groupedSkillList[newRateeSkill.category]
        ? this.groupedSkillList[newRateeSkill.category]
        : []
      categoryList.push(newRateeSkill)

      Vue.set(this.groupedSkillList, newRateeSkill.category, categoryList)
    }

    groupSkills (
      skills: IcoachSkillShortInfo[]
    ): {
      [key: number]: IcoachSkillShortInfo[]
    } {
      return skills.reduce((rv: any, skill: IcoachSkillShortInfo) => {
        (rv[skill.category] = rv[skill.category] || []).push(skill)
        return rv
      }, {})
    }

    publish (): void {
      this.$modal.show('confirm-publish-modal')
    }

    hideConfirmPublishRatee (): void {
      this.raterToRemove = null
      this.$modal.hide('confirm-publish-modal')
      this.modalError = ''
    }

    async confirmRemovePublishRatee (): Promise < void > {
      try {
        this.ratee = await TsService.publish(
          this.tsManager.id,
          this.tsManagerRateeId
        )
        this.$modal.hide('confirm-publish-modal')
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data
          this.modalError = detail
        } else {
          throw error
        }
      }
    }
}

